module.exports = __webpack_public_path__ + "img/company2-1.4ec91178.png";